var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"circle-border d-flex justify-content-center align-items-center"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.loaded)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }